import { render, staticRenderFns } from "./KnowledgeManageSettingsRow.vue?vue&type=template&id=4041652e&scoped=true&"
import script from "./KnowledgeManageSettingsRow.vue?vue&type=script&lang=js&"
export * from "./KnowledgeManageSettingsRow.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeManageSettingsRow.vue?vue&type=style&index=0&id=4041652e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041652e",
  null
  
)

export default component.exports